import {
    FORM_SEARCH_INPUT_ID,
    SET_GROUP_NOTIFICATIONS_AS_READ_BUTTON_ID,
    SHOW_ALL_NOTIFICATIONS_BUTTON_ID,
    USER_MENU_LOGOUT_ITEM_ID,
    USER_MENU_SETTINGS_ITEM_ID,
    USER_MENU_TOGGLE_THEME_ITEM_ID,
} from "../constants";
import { MenuPanelItemId } from "../panelItems";
import { FocusableItemId, MenuFocusableItemType, MenuNavigationSectionType } from "./types";
import { createFocusableItemId } from "./utils";

/**
 * Id navigačního uzlu pro logo.
 */
export const LOGO_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(MenuPanelItemId.logo, MenuFocusableItemType.panelItem, MenuNavigationSectionType.static);

/**
 * Id navigačního uzlu pro sekci Rychlý přístup.
 */
export const QUICK_ACCESS_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(MenuPanelItemId.quickAccess, MenuFocusableItemType.panelItem, MenuNavigationSectionType.static);

/**
 * Id navigačního uzlu pro pole vyhledávání formulářů.
 */
export const FORM_SEARCH_INPUT_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(FORM_SEARCH_INPUT_ID, MenuFocusableItemType.searchInput, MenuNavigationSectionType.static);

/**
 * Id navigačního uzlu pro sekci menu uživatele.
 */
export const USER_MENU_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(MenuPanelItemId.user, MenuFocusableItemType.panelItem, MenuNavigationSectionType.static);

/**
 * Id navigačního uzlu pro tlačítko odhlášení v menu uživatele.
 */
export const LOGOUT_BUTTON_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(USER_MENU_LOGOUT_ITEM_ID, MenuFocusableItemType.userMenuItem, MenuNavigationSectionType.static);

/**
 * Id navigačního uzlu pro tlačítko nastavení v menu uživatele.
 */
export const SETTINGS_BUTTON_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(USER_MENU_SETTINGS_ITEM_ID, MenuFocusableItemType.userMenuItem, MenuNavigationSectionType.static);

/**
 * Id navigačního uzlu pro tlačítko změny tématu.
 */
export const TOGGLE_THEME_BUTTON_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(USER_MENU_TOGGLE_THEME_ITEM_ID, MenuFocusableItemType.userMenuItem, MenuNavigationSectionType.static);

/**
 * Id navigačního uzlu pro položku tlačítka pro zobrazení všech notifikací.
 */
export const SHOW_ALL_NOTIFICATIONS_BUTTON_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(SHOW_ALL_NOTIFICATIONS_BUTTON_ID, MenuFocusableItemType.showAllNotificationsButton, MenuNavigationSectionType.static);

/**
 * Id navigačního uzlu pro položku tlačítka pro označení všech notifikací skupiny jako přečtených.
 */
export const SET_GROUP_NOTIFICATIONS_AS_READ_BUTTON_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(SET_GROUP_NOTIFICATIONS_AS_READ_BUTTON_ID, MenuFocusableItemType.setGroupNotificationsAsReadButton, MenuNavigationSectionType.static);

/**
 * Id navigačního uzlu pro tlačítko rozbalení menu.
 */
export const MENU_EXPAND_BUTTON_FOCUSABLE_ID: FocusableItemId =
    createFocusableItemId(MenuPanelItemId.expandButton, MenuFocusableItemType.panelItem, MenuNavigationSectionType.static);
